var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-page"},[_c('div',[_vm._v(" "+_vm._s(_vm.statusCode)+" ")]),_c('div',[_vm._v(" Error Page goes here ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }